import api from "@/lib/api";

export const CHAT_MAX_BYTES = 25 * 1024 * 1024;
export const CHAT_ACCEPT = "image/jpeg,image/png,image/webp,image/heic,image/heif,.heic,.heif,application/pdf";

export async function uploadFile(initUrl, file, onProgress) {
  const { data } = await api.post(initUrl, { filename: file.name, size: file.size });
  const step = data.chunk_size;
  const total = Math.ceil(file.size / step);
  for (let i = 0; i < total; i += 1) {
    const blob = file.slice(i * step, Math.min(file.size, (i + 1) * step));
    await api.put(`/chat-files/upload/${data.upload_id}/chunk`, blob, {
      params: { index: i },
      headers: { "Content-Type": "application/octet-stream" },
    });
    onProgress(Math.round(((i + 1) / total) * 95));
  }
  const res = await api.post(`/chat-files/upload/${data.upload_id}/complete`);
  onProgress(100);
  return res.data;
}

export const uploadChatFile = (threadType, refId, file, onProgress) =>
  uploadFile(`/chat-files/${threadType}/${refId}/init`, file, onProgress);
